export const DietCategoriesEnum = {
  NONE: "none",
  VEGETARIAN: "vegetarian",
  VEGAN: "vegan",
  KETO: "keto",
  LOW_CARB: "low_carb",
  HYPO_CALORIC: "hypocaloric",
  HYPER_CALORIC: "hyper_caloric",
  LOW_GLYCEMIC: "low_glycemic",
};

export const LitersPerDayEnum = {
  ONE_OR_LESS : "one_or_less",
  AROUND_TWO : "around_two",
  THREE_OR_MORE : "three_or_more",
}